/**
 *
 * Custom error for reported errors in CARTO Maps API.
 * Provides useful debugging information in console and context for applications.
 *
 */
export class CartoAPIError extends Error {
    constructor(error, errorContext, response, responseJson) {
        let responseString = 'Failed to connect';
        if (response) {
            responseString = 'Server returned: ';
            if (response.status === 400) {
                responseString += 'Bad request';
            }
            else if (response.status === 401 || response.status === 403) {
                responseString += 'Unauthorized access';
            }
            else if (response.status === 404) {
                responseString += 'Not found';
            }
            else {
                responseString += 'Error';
            }
            responseString += ` (${response.status}):`;
        }
        responseString += ` ${error.message || error}`;
        let message = `${errorContext.requestType} API request failed`;
        message += `\n${responseString}`;
        for (const key of Object.keys(errorContext)) {
            if (key === 'requestType')
                continue; // eslint-disable-line no-continue
            message += `\n${formatErrorKey(key)}: ${errorContext[key]}`;
        }
        message += '\n';
        super(message);
        this.name = 'CartoAPIError';
        this.response = response;
        this.responseJson = responseJson;
        this.error = error;
        this.errorContext = errorContext;
    }
}
/**
 * Converts camelCase to Camel Case
 */
function formatErrorKey(key) {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
}
